import { useSuggestions } from '@/extensions/Mention/hooks'
import {
  type FileWithType,
  MentionList,
} from '@/extensions/Mention/knowledge-base/MentionList'
import type {
  KnowledgeBaseSuggestionParams,
  SuggestionArgs,
  Suggestions,
} from '@/extensions/Mention/types'

import { cleanFileName } from '@/helpers/file'

import type { File } from '@/types/File'

export interface KnowledgeBaseSuggestionsProps {
  params: KnowledgeBaseSuggestionParams
  onSelect?: (item: FileWithType) => void
}

const getLabel = (file: FileWithType) => {
  return cleanFileName(file.name)
}

export const useKnowledgeBaseSuggestions = (
  props: KnowledgeBaseSuggestionsProps,
): Suggestions | undefined => {
  const suggestion: SuggestionArgs = {
    type: 'knowledge-base',
    pursuitId: props.params.pursuitId,
    orgId: props.params.orgId,
  }

  // resorting to loading items within the component, rather than fetching them here;
  // this is because the tiptap editor caches the items at initial render, which doesn't
  // give us enough time to fetch the items from the server
  return useSuggestions({
    component: MentionList,
    items: [],
    suggestion,
    getLabel,
    onSelect: props.onSelect,
  })
}
